import React, { useState, useCallback } from 'react';
import { IoClose, IoRemove, IoChevronUp } from 'react-icons/io5';
import Swal from 'sweetalert2';
import LeftMenu from './LeftMenu';
import { findReportByInlinePath, userCanAccessReport } from '../pages/reportsConfig';
import { initializeWebUserInfo, getWebUserInfo } from '../utlilities/webConfig';

// Import all page components
import SalesEntry from '../pages/SalesEntry';
import SalesReturn from '../pages/SalesReturn';
import PurchaseEntry from '../pages/Purchase';
import PurchaseEdit from '../pages/PurchaseEdit';
import PurchaseReturn from '../pages/PurchaseReturn';
import ProductMaster from '../pages/ProductMaster';
import SupplierMaster from '../pages/SupplierMaster';
import ChemicalMaster from '../pages/ChemicalMaster';
import DepartmentMaster from '../pages/DepartmentMaster';
import OpeningStockEntry from '../pages/OpeningStockEntry';
import StockAdjustment from '../pages/StockAdjustment';
import StockTransfer from '../pages/StockTransfer';
import ExpenseEntry from '../pages/ExpenseEntry';
import Reports from '../pages/Reports';
import BatchStock from '../pages/BatchStock';
import Settings from '../pages/Settings';
import ReturnAproval from '../pages/ReturnAproval';
import UserMaster from '../pages/UserMaster';
import Dashboard from '../pages/Dashboard';
import StockAdjustmentBillWise from '../pages/reports/stockadjustmentbillwise';
import PurchaseBillWise from '../pages/reports/purchasebillwise';
import PurchaseItemWise from '../pages/reports/purchaseitemwise';
import SalesBillWise from '../pages/reports/salesbillwise';
import SalesBillWiseIP from '../pages/reports/salesbillwiseip';
import SalesSectionWise from '../pages/reports/salessectionwise';
import SalesDoctorWise from '../pages/reports/salesdoctorwise';
import SalesReturnBillWise from '../pages/reports/salesreturnbillwise';
import OpeningStockBillWise from '../pages/reports/openingstockbillwise';
import StockConsumptionBillWise from '../pages/reports/stockconsumptionbillwise';
import SalesBillItemWise from '../pages/reports/salesbillitemwise';
import SalesLedger from '../pages/reports/salesledger';
import ReorderLevel from '../pages/reports/reorderlevel';
import StockLedger from '../pages/reports/stockledger';
import ExpiryReport from '../pages/reports/expiryreport';
import DeadStockReport from '../pages/reports/deadstockreport';
import OpBilling from '../pages/OpBilling';
import Payments from '../pages/Payments';
import SupplierMapping from '../pages/SupplierMapping';
import ItemPrivilegeCard from '../pages/ItemPrivilegeCard';
import Patients from '../pages/Patients';
import PatientDetails from '../pages/PatientDetails';
import PharmacyCollectionReport from '../pages/reports/PharmacyCollectionReport';
import PurchaseLedger from '../pages/reports/purchaseledger';
import PurchaseReturnReport from '../pages/reports/purchasereturnreport';
import FOCItemsReport from '../pages/reports/focitemsreport';
import ShortBooks from '../pages/ShortBooks';
import ItemMovingReport from '../pages/reports/itemmovingreport';
import SalesPatientWisePage from '../pages/reports/salespatientwise';
import DayClose from '../pages/Dayclose';
import SupplierPayment from '../pages/SupplierPayment';
import PharmacyIPBilling from '../pages/IpSalesEntry';
import IpSalesReturn from '../pages/IpSalesReturn';


// Route to Component mapping
const routeComponents = {
  'salesentry': { component: SalesEntry, title: 'Sales Entry' },
  'ipsalesentry': { component: PharmacyIPBilling, title: 'IP Sales Entry' },
  'ipsalesreturn': { component: IpSalesReturn, title: 'IP Sales Return' },
  'salesreturn': { component: SalesReturn, title: 'Sales Return' },
  'purchaseentry': { component: PurchaseEntry, title: 'Purchase Entry' },
  'purchaseedit/:invoiceNo/:sequence/:editNo': { component: PurchaseEdit, title: 'Purchase Edit' },
  'purchasereturn': { component: PurchaseReturn, title: 'Purchase Return' },
  'productmaster': { component: ProductMaster, title: 'Product Master' },
  'suppliermaster': { component: SupplierMaster, title: 'Supplier Master' },
  'chemicalmaster': { component: ChemicalMaster, title: 'Chemical Master' },
  'departmentmaster': { component: DepartmentMaster, title: 'Department Master' },
  'openingstockentry': { component: OpeningStockEntry, title: 'Opening Stock Entry' },
  'stockadjustment': { component: StockAdjustment, title: 'Stock Adjustment' },
  'stocktransfer': { component: StockTransfer, title: 'Stock Transfer' },
  'expenseentry': { component: ExpenseEntry, title: 'Expense Entry' },
  'reports': { component: Reports, title: 'Reports Hub' },
  'batchstock': { component: BatchStock, title: 'Batch Stock' },
  'settings': { component: Settings, title: 'Settings' },
  'returnapproval': { component: ReturnAproval, title: 'Return Approval' },
  'usermaster': { component: UserMaster, title: 'User Master' },
  'dashboard': { component: Dashboard, title: 'Dashboard' },
  'stockadjustmentbill-wise': { component: StockAdjustmentBillWise, title: 'Stock Adjustment Bill Wise' },
  'purchasebill-wise': { component: PurchaseBillWise, title: 'Purchase Bill Wise' },
  'purchaseitem-wise': { component: PurchaseItemWise, title: 'Purchase Item Wise' },
  'salesbill-wise': { component: SalesBillWise, title: 'Sales Bill Wise' },
  'salesbill-wise-ip': { component: SalesBillWiseIP, title: 'IP Sales Bill Wise' },
  'salessection-wise': { component: SalesSectionWise, title: 'Sales Section Wise' },
  'salesdoctor-wise': { component: SalesDoctorWise, title: 'Sales Doctor Wise' },
  'salesreturnbill-wise': { component: SalesReturnBillWise, title: 'Sales Return Bill Wise' },
  'openingstockbill-wise': { component: OpeningStockBillWise, title: 'Opening Stock Bill Wise' },
  'stockconsumptionbill-wise': { component: StockConsumptionBillWise, title: 'Stock Consumption Bill Wise' },
  'salesitem-wise': { component: SalesBillItemWise, title: 'Sales Bill Item Wise' },
  'salesledger': { component: SalesLedger, title: 'Sales Ledger' },
  'stockreorder-level': { component: ReorderLevel, title: 'Reorder Level Report' },
  'stockledger': { component: StockLedger, title: 'Stock Ledger' },
  'stockexpiry-report': { component: ExpiryReport, title: 'Expiry Report' },
  'stockdead-stock': { component: DeadStockReport, title: 'Dead Stock Report' },
  'opbilling': { component: OpBilling, title: 'General Billing' },
  'payments': { component: Payments, title: 'Payments' },
  'suppliermapping': { component: SupplierMapping, title: 'Supplier Excel Mapping' },
  'itemprivilegecard': { component: ItemPrivilegeCard, title: 'Item Privilege Card' },
  'patients': { component: Patients, title: 'Patients Directory' },
  'patientdetails/:patientId': { component: PatientDetails, title: 'Patient Details' },
  'pharmacycollection-report': { component: PharmacyCollectionReport, title: 'Pharmacy Collection Report' },
  'collectionpharmacy-collection': { component: PharmacyCollectionReport, title: 'Pharmacy Collection Report' },
  'purchaseledger': { component: PurchaseLedger, title: 'Purchase Ledger' },
  'purchasereturn-report': { component: PurchaseReturnReport, title: 'Purchase Return Report' },
  'purchasefoc-items': { component: FOCItemsReport, title: 'FOC Items Report' },
  'shortbooks': { component: ShortBooks, title: 'Short Books' },
  'salesitem-moving': { component: ItemMovingReport, title: 'Item Moving Report' },
  'salespatient-wise': { component: SalesPatientWisePage, title: 'Patient Wise Summary' },
  'dayclose': { component: DayClose, title: 'Day Close' },
  'supplierpayment': { component: SupplierPayment, title: 'Supplier Payment' },
};

const isElectron = () =>
  typeof window !== 'undefined' && window.process && window.process.type;

let ipcRenderer;
if (isElectron()) {
  ipcRenderer = window.require('electron').ipcRenderer;
}

const processReportTabPermissions = (roles) => {
  const permissionsMap = {};
  const list = Array.isArray(roles) ? roles : [];
  list.forEach((role) => {
    (role.modules || []).forEach((module) => {
      permissionsMap[module.moduleName] = module.permissions;
    });
  });
  return permissionsMap;
};

// Create a context for tab management
export const TabContext = React.createContext(null);

let tabIdCounter = 0;

// Explicit color gradient mapping for each menu item
const getTabGradient = (path) => {
  // Handle dynamic routes like patientdetails/123
  const basePath = path.startsWith('patientdetails/')
    ? 'patientdetails'
    : path.startsWith('purchaseedit/')
      ? 'purchaseedit'
      : path;

  // Default gradient (fallback for unknown routes)
  const defaultGradient = {
    from: 'from-slate-600',
    to: 'to-slate-800',
    text: 'text-white',
    border: 'border-b-slate-600'
  };

  // Explicit color mapping for each menu item - vibrant colors with white text
  const routeColors = {
    'salesentry': { from: 'from-blue-600', to: 'to-blue-800', text: 'text-white', border: 'border-b-blue-600' },
    'salesreturn': { from: 'from-red-600', to: 'to-red-800', text: 'text-white', border: 'border-b-red-600' },
    'purchaseentry': { from: 'from-green-600', to: 'to-green-800', text: 'text-white', border: 'border-b-green-600' },
    'purchaseedit': { from: 'from-green-600', to: 'to-green-800', text: 'text-white', border: 'border-b-green-600' },
    'purchasereturn': { from: 'from-orange-600', to: 'to-orange-800', text: 'text-white', border: 'border-b-orange-600' },
    'productmaster': { from: 'from-indigo-600', to: 'to-indigo-800', text: 'text-white', border: 'border-b-indigo-600' },
    'suppliermaster': { from: 'from-purple-600', to: 'to-purple-800', text: 'text-white', border: 'border-b-purple-600' },
    'chemicalmaster': { from: 'from-teal-600', to: 'to-teal-800', text: 'text-white', border: 'border-b-teal-600' },
    'departmentmaster': { from: 'from-orange-600', to: 'to-orange-800', text: 'text-white', border: 'border-b-orange-600' },
    'openingstockentry': { from: 'from-green-700', to: 'to-green-900', text: 'text-white', border: 'border-b-green-700' },
    'stockadjustment': { from: 'from-amber-600', to: 'to-amber-800', text: 'text-white', border: 'border-b-amber-600' },
    'stocktransfer': { from: 'from-cyan-600', to: 'to-cyan-800', text: 'text-white', border: 'border-b-cyan-600' },
    'expenseentry': { from: 'from-orange-600', to: 'to-orange-800', text: 'text-white', border: 'border-b-orange-600' },
    'reports': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'batchstock': { from: 'from-pink-600', to: 'to-pink-800', text: 'text-white', border: 'border-b-pink-600' },
    'settings': { from: 'from-orange-600', to: 'to-orange-800', text: 'text-white', border: 'border-b-orange-600' },
    'returnapproval': { from: 'from-purple-700', to: 'to-purple-900', text: 'text-white', border: 'border-b-purple-700' },
    'usermaster': { from: 'from-indigo-600', to: 'to-purple-700', text: 'text-white', border: 'border-b-indigo-600' },
    'dashboard': { from: 'from-blue-600', to: 'to-indigo-700', text: 'text-white', border: 'border-b-blue-600' },
    'stockadjustmentbill-wise': { from: 'from-amber-600', to: 'to-orange-700', text: 'text-white', border: 'border-b-amber-600' },
    'purchasebill-wise': { from: 'from-green-600', to: 'to-emerald-700', text: 'text-white', border: 'border-b-green-600' },
    'purchaseitem-wise': { from: 'from-teal-600', to: 'to-cyan-700', text: 'text-white', border: 'border-b-teal-600' },
    'salesbill-wise': { from: 'from-blue-600', to: 'to-cyan-700', text: 'text-white', border: 'border-b-blue-600' },
    'salesbill-wise-ip': { from: 'from-violet-600', to: 'to-indigo-700', text: 'text-white', border: 'border-b-violet-600' },
    'salessection-wise': { from: 'from-indigo-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-indigo-600' },
    'salesdoctor-wise': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'salespatient-wise': { from: 'from-blue-600', to: 'to-indigo-700', text: 'text-white', border: 'border-b-blue-600' },
    'salesitem-moving': { from: 'from-violet-600', to: 'to-purple-700', text: 'text-white', border: 'border-b-violet-600' },
    'salesreturnbill-wise': { from: 'from-red-600', to: 'to-rose-700', text: 'text-white', border: 'border-b-red-600' },
    'openingstockbill-wise': { from: 'from-green-700', to: 'to-green-900', text: 'text-white', border: 'border-b-green-700' },
    'stockconsumptionbill-wise': { from: 'from-orange-600', to: 'to-amber-700', text: 'text-white', border: 'border-b-orange-600' },
    'salesitem-wise': { from: 'from-cyan-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-cyan-600' },
    'salesledger': { from: 'from-cyan-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-cyan-600' },
    'stockreorder-level': { from: 'from-pink-600', to: 'to-rose-700', text: 'text-white', border: 'border-b-pink-600' },
    'stockexpiry-report': { from: 'from-amber-600', to: 'to-orange-700', text: 'text-white', border: 'border-b-amber-600' },
    'stockdead-stock': { from: 'from-slate-600', to: 'to-slate-800', text: 'text-white', border: 'border-b-slate-600' },
    'opbilling': { from: 'from-purple-600', to: 'to-violet-700', text: 'text-white', border: 'border-b-purple-600' },
    'payments': { from: 'from-green-600', to: 'to-teal-700', text: 'text-white', border: 'border-b-green-600' },
    'suppliermapping': { from: 'from-teal-600', to: 'to-emerald-700', text: 'text-white', border: 'border-b-teal-600' },
    'itemprivilegecard': { from: 'from-pink-600', to: 'to-pink-800', text: 'text-white', border: 'border-b-pink-600' },
    'patients': { from: 'from-blue-600', to: 'to-cyan-700', text: 'text-white', border: 'border-b-blue-600' },
    'patientdetails': { from: 'from-indigo-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-indigo-600' },
    'pharmacycollection-report': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'collectionpharmacy-collection': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'stockledger': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'purchaseledger': { from: 'from-green-600', to: 'to-emerald-700', text: 'text-white', border: 'border-b-green-600' },
    'purchasereturn-report': { from: 'from-orange-600', to: 'to-red-700', text: 'text-white', border: 'border-b-orange-600' },
    'purchasefoc-items': { from: 'from-emerald-600', to: 'to-teal-700', text: 'text-white', border: 'border-b-emerald-600' },
    'shortbooks': { from: 'from-cyan-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-cyan-600' },
    'dayclose': { from: 'from-purple-600', to: 'to-violet-700', text: 'text-white', border: 'border-b-purple-600' },
    'supplierpayment': { from: 'from-indigo-600', to: 'to-blue-700', text: 'text-white', border: 'border-b-indigo-600' },
    'ipsalesentry': { from: 'from-red-700', to: 'to-red-900', text: 'text-white', border: 'border-b-red-700' },
    'ipsalesreturn': { from: 'from-green-600', to: 'to-green-800', text: 'text-white', border: 'border-b-green-600' },
  };

  return routeColors[basePath] || defaultGradient;
};

const TabbedLayout = () => {
  const [tabs, setTabs] = useState([]);
  const [activeTabId, setActiveTabId] = useState(null);
  // Open a new tab (always creates new, allows multiple of same route)
  const openTab = useCallback(async (routePath, title) => {
    const cleanPath = routePath.startsWith('/') ? routePath.substring(1) : routePath;

    const { report } = findReportByInlinePath(cleanPath);
    if (report) {
      let userRolesData;
      let userinfo;
      try {
        if (isElectron()) {
          userRolesData = await ipcRenderer.invoke('store-get', 'user_role');
          userinfo = await ipcRenderer.invoke('store-get', 'userInfo');
        } else {
          initializeWebUserInfo();
          userRolesData = getWebUserInfo().user_role;
          userinfo = getWebUserInfo().userInfo;
        }
      } catch {
        userRolesData = [];
        userinfo = {};
      }
      const perms = processReportTabPermissions(userRolesData);
      if (!userCanAccessReport(userinfo || {}, perms, report)) {
        Swal.fire({
          title: 'Access Denied',
          text: "You don't have permission to open this report.",
          icon: 'error',
          confirmButtonColor: '#3085d6',
        });
        return null;
      }
    }

    // Count existing tabs of same type for numbering
    const sameTypeTabs = tabs.filter(t => t.path === cleanPath);
    const tabNumber = sameTypeTabs.length + 1;
    const baseTitle = title || routeComponents[cleanPath]?.title || cleanPath;
    const displayTitle = tabNumber > 1 ? `${baseTitle} (${tabNumber})` : baseTitle;

    const newTab = {
      id: `tab-${++tabIdCounter}`,
      path: cleanPath,
      title: displayTitle,
      minimized: false,
    };

    setTabs(prev => [...prev, newTab]);
    setActiveTabId(newTab.id);
    return newTab.id;
  }, [tabs]);

  // Close a tab
  const closeTab = useCallback((tabId) => {
    setTabs(prev => {
      const filtered = prev.filter(t => t.id !== tabId);
      if (activeTabId === tabId) {
        // Switch to last tab or null
        const newActive = filtered.length > 0 ? filtered[filtered.length - 1].id : null;
        setActiveTabId(newActive);
      }
      return filtered;
    });
  }, [activeTabId]);

  // Close all tabs
  const closeAllTabs = useCallback(() => {
    setTabs([]);
    setActiveTabId(null);
  }, []);

  // Focus a tab
  const focusTab = useCallback((tabId) => {
    const tab = tabs.find(t => t.id === tabId);
    if (tab) {
      if (tab.minimized) {
        setTabs(prev => prev.map(t => t.id === tabId ? { ...t, minimized: false } : t));
      }
      setActiveTabId(tabId);
    }
  }, [tabs]);

  // Minimize a tab
  const minimizeTab = useCallback((tabId) => {
    setTabs(prev => prev.map(t => t.id === tabId ? { ...t, minimized: true } : t));
    // Switch to another non-minimized tab
    const otherTab = tabs.find(t => t.id !== tabId && !t.minimized);
    if (otherTab) {
      setActiveTabId(otherTab.id);
    }
  }, [tabs]);

  // Restore a tab
  const restoreTab = useCallback((tabId) => {
    setTabs(prev => prev.map(t => t.id === tabId ? { ...t, minimized: false } : t));
    setActiveTabId(tabId);
  }, []);

  const activeTab = tabs.find(t => t.id === activeTabId);
  const ActiveComponent = activeTab ? routeComponents[activeTab.path]?.component : null;

  return (
    <TabContext.Provider value={{ openTab, closeTab, closeAllTabs, focusTab, minimizeTab, restoreTab, tabs, activeTabId }}>
      <div className="flex h-screen overflow-hidden bg-gray-50">
        {/* Left Menu */}
        <div className="flex-shrink-0">
          <LeftMenu />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Tab Bar */}
          {tabs.length > 0 && (
            <div className="flex items-center bg-white border-b border-gray-200 shadow-sm">
              <div className="flex items-center flex-1 overflow-x-auto min-w-0">
                {tabs.map((tab) => {
                  const isActive = tab.id === activeTabId;
                  const isMinimized = tab.minimized;
                  const gradient = getTabGradient(tab.path);

                  return (
                    <div
                      key={tab.id}
                      onClick={() => focusTab(tab.id)}
                      className={`
                        flex items-center gap-2 px-4 py-1 border-r border-gray-200 cursor-pointer
                        transition-all duration-200 min-w-[150px] max-w-[250px]
                        ${isActive
                          ? `bg-gradient-to-r ${gradient.from} ${gradient.to} border-b-2 ${gradient.border} ${gradient.text} shadow-md`
                          : 'bg-gray-100 hover:bg-gray-200 text-gray-600 opacity-70 shadow-inner'
                        }
                        ${isMinimized ? 'opacity-50' : ''}
                      `}
                    >
                      <div className="flex-1 truncate">
                        <span className={`text-sm font-medium ${isActive ? 'font-semibold' : ''}`}>
                          {tab.title}
                        </span>
                      </div>

                      <div className="flex items-center gap-1">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            isMinimized ? restoreTab(tab.id) : minimizeTab(tab.id);
                          }}
                          className={`
                            p-1 rounded transition-colors
                            ${isActive
                              ? 'text-white hover:bg-white/20'
                              : isMinimized
                                ? 'text-indigo-600 hover:bg-gray-200'
                                : 'text-gray-500 hover:bg-gray-200'
                            }
                          `}
                          title={isMinimized ? 'Restore' : 'Minimize'}
                        >
                          {isMinimized ? <IoChevronUp size={14} /> : <IoRemove size={14} />}
                        </button>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            closeTab(tab.id);
                          }}
                          className={`
                            p-1 rounded transition-colors
                            ${isActive
                              ? 'text-white hover:bg-red-500/30 hover:text-white'
                              : 'text-gray-500 hover:bg-red-100 hover:text-red-600'
                            }
                          `}
                          title="Close"
                        >
                          <IoClose size={14} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              <button
                onClick={closeAllTabs}
                className="flex-shrink-0 flex items-center gap-1 px-3 py-1.5 mx-2 text-xs font-medium text-gray-600 bg-gray-100 hover:bg-red-50 hover:text-red-600 border border-gray-200 rounded transition-colors"
                title="Close all tabs"
              >
                <IoClose size={14} />
                Close All
              </button>
            </div>
          )}

          {/* Content Area */}
          <div className="flex-1 overflow-auto relative">
            {tabs.length === 0 ? (
              <Dashboard />
            ) : (
              <>
                {tabs.map((tab) => {
                  // Handle dynamic routes like patientdetails/123
                  let TabComponent = null;
                  if (tab.path.startsWith('patientdetails/')) {
                    TabComponent = PatientDetails;
                  } else if (tab.path.startsWith('purchaseedit/')) {
                    TabComponent = PurchaseEdit;
                  } else {
                    TabComponent = routeComponents[tab.path]?.component;
                  }

                  if (!TabComponent) return null;
                  const isVisible = tab.id === activeTabId && !tab.minimized;
                  return (
                    <div
                      key={tab.id}
                      style={{ display: isVisible ? 'block' : 'none' }}
                      className="h-full"
                    >
                      <TabComponent tabPath={tab.path} tabId={tab.id} />
                    </div>
                  );
                })}
                {(!activeTab || activeTab.minimized) && (
                  <div className="flex items-center justify-center h-full text-gray-500">
                    <p>Select a tab or open a new module from the menu</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </TabContext.Provider>
  );
};

export default TabbedLayout;

